import styled, { css, keyframes } from 'styled-components';

export const spin = keyframes`
  from {
    --gradient-angle: 0deg;
  }
  to {
    --gradient-angle: 360deg;
  }
`;

export const borderWidth = keyframes`
  0%, 95% {
    padding: 2px;
  }
  100% {
    padding: 1px;
  }
`;

export const Wrapper = styled.div`
  ${({ $disabled }) => css`
    position: relative;
    max-width: 800px;
    width: 100%;
    margin: 0px auto;
    padding: 1px;
    z-index: 1;
    animation: ${borderWidth} 8s linear;

    @supports (background: conic-gradient(#000, #000)) {
      @property --gradient-angle {
        syntax: '<angle>';
        initial-value: 0deg;
        inherits: false;
      }
    }

    &::after, &::before{
      ${$disabled && css`
        background-image: none;
        display: none;
      `}

      content: '';
      position: absolute;
      height: 100%;
      width: 100%;
      background-image: conic-gradient(
        from var(--gradient-angle),
        #2E93EE 0%,
        #2E93EE 3%,
        #2F92ED 6%,
        #3091ED 9%,
        #3190EC 12%,
        #338EEB 15%,
        #358CE9 18%,
        #3789E8 21%,
        #3A86E6 24%,
        #3D83E4 27%,
        #417FE1 30%,
        #457BDF 33%,
        #4976DC 36%,
        #4E71D9 39%,
        #536CD5 42%,
        #5E60CE 45%,
        #5E60CE 48%,
        #5E60CE 51%,
        #5E60CE 54%,
        #5E60CE 57%,
        #5E60CE 60%,
        #5E60CE 63%,
        #5E60CE 66%,
        #3D83E4 69%,
        #3A86E6 72%,
        #3789E8 75%,
        #358CE9 78%,
        #338EEB 81%,
        #3190EC 84%,
        #3091ED 87%,
        #2F92ED 90%,
        #2E93EE 93%,
        #2E93EE 96%,
        #2E93EE 100%
      );
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      z-index: -1;
      border-radius: 22px;
      animation: ${spin} 4s linear infinite;
      animation-delay: 0s;
      animation-iteration-count: 2;
      animation-fill-mode: backwards;

    }

    &::before{
      filter: blur(16px);
      opacity: 0.2;
    }
  `}
`;

export const Form = styled.form`
  ${({ theme, $disabled, $isFullScreen }) => css`
    border-radius: 21px;
    display: flex;
    flex-direction: column;
    height: 132px;
    width: 100%;
    z-index: 1;
    padding: 20px;
    position: relative;
    background: ${theme.v2.colors.neutral.highPure};

    ${$disabled && css`
      background-color: ${theme.v2.colors.neutral.highLight};
      cursor: not-allowed;
    `}

    ${$isFullScreen && css`
      margin: 0px auto;
      max-width: 880px;
      width: 100%;
    `}
  `}
`;

export const TextArea = styled.textarea`
  ${({ theme }) => css`
    height: 64px;
    border: 0px;
    resize: none;
    outline: none;
    placeholder: ${theme.v2.colors.neutral.highMedium};
    font-family: ${theme.v2.font.family.primary};
    font-size: ${theme.v2.font.sizes.xs};
    font-weight: ${theme.v2.font.weights.regular};
    line-height: ${theme.v2.font.lineHeight.text};
    color: ${theme.v2.colors.neutral.lowDark};
    background: ${theme.v2.colors.neutral.highPure};

    &:disabled {
      cursor: not-allowed;
      background: ${theme.v2.colors.neutral.highLight};
    }
  `}
`;

export const ActionsWrapper = styled.div`
  display: flex;
  align-items: flex-end;
  gap: 24px;
  width: fit-content;
  align-self: end;
`;

export const ButtonSubmitAdapter = styled.div`
  ${({ theme }) => css`
    display: flex;
    height: 36px;
    margin-left: auto;
    width: 36px;

    button {
      border-radius: 100%;
      height: 36px;
      padding: 0px;
      width: 36px;

      &:disabled {
          background-color: ${theme.v2.colors.neutral.highMedium};
      }
    }
  `}
`;

export const ButtonRecordingAdapter = styled.button`
  ${() => css`
    display: flex;
    height: 28px;
    margin-left: auto;
    width: fit-content;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    border: none;
    background: none;
    padding: 0;

    &:disabled {
      cursor: not-allowed;
    }
  `}
`;
